import { Outlet } from "react-router-dom";
import TopNav from "../Nav/TopNav";
import BottomNav from "../Nav/BottomNav";

import "./TopNavLayout.css";

const TopNavLayout = () => {
  return (
    <div className='topNavLayout'>
      <TopNav />
      <div className='mainScreen'>
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
};

export default TopNavLayout;
